import React from 'react';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import useQuerySearchParams from 'routes/surface/hooks/use-query-search-params';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';

interface UseSnippetSearchParametersOperations {
  setSnippetIdToSearchParams(surface: string, snippet: string): void;
  removeSnippetIdFromSearchParams(surface: string, snippet: string): void;
}

export default function useSnippetSearchParams(
  showNodeModal,
): UseSnippetSearchParametersOperations {
  const operations = useSnippetSearchParamsOperations();

  const { id } = useParams<{ id: string }>();

  const { findNodeById } = useFindNodeInCache(id);

  const searchParams = useQuerySearchParams();

  const snippet = searchParams.get('snippet');

  React.useEffect(() => {
    const surfaceNode = snippet && findNodeById(snippet);

    if (surfaceNode) {
      showNodeModal(surfaceNode);
    }
  }, [snippet]);

  return operations;
}

// eslint-disable-next-line unicorn/prevent-abbreviations
export function useSnippetSearchParamsOperations(): UseSnippetSearchParametersOperations {
  const history = useHistory();
  const searchParams = useQuerySearchParams();

  function removeSnippetIdFromSearchParams(
    surface: string,
    snippetId: string,
  ): void {
    const snippet = searchParams.get('snippet');

    if (snippet && snippet === snippetId) {
      searchParams.delete('snippet');
      history.replace({
        search: searchParams.toString(),
      });
    }
  }

  function setSnippetIdToSearchParams(surface: string, snippet: string): void {
    setTimeout(() => {
      searchParams.set('snippet', snippet);
      history.push({
        pathname: '/surface/' + surface,
        search: searchParams.toString(),
      });
    }, 500);
  }

  return { setSnippetIdToSearchParams, removeSnippetIdFromSearchParams };
}
